
import { PickupCorporateAddress } from "@/domain/entities/PickupSchedule";
import { Vue, Options, prop } from "vue-class-component";

class Props {
  address = prop<PickupCorporateAddress>({
    default: new PickupCorporateAddress()
  });
  loading = prop<boolean>({
    default: false,
    type: Boolean
  });
  canSubmit = prop<boolean>({
    default: false,
    type: Boolean
  });
  isSubmitting = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  emits: ["submit", "changeAddress", "addAddress"]
})
export default class PickupAddressSidebarCard extends Vue.with(Props) {
  get hasAddress(): boolean {
    return this.address?.pcaId > 0;
  }

  get formattedAddressName(): string {
    const name = this.address?.pcaName || "";
    if (name.length > 25) {
      return `${name.substring(0, 25)}...`;
    }
    return name;
  }
}
